var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19 7.5L18.1327 19.6425C18.0579 20.6891 17.187 21.5 16.1378 21.5H7.86224C6.81296 21.5 5.94208 20.6891 5.86732 19.6425L5 7.5M10 11.5V17.5M14 11.5V17.5M15 7.5V4.5C15 3.94772 14.5523 3.5 14 3.5H10C9.44772 3.5 9 3.94772 9 4.5V7.5M4 7.5H20",
    stroke: "#CC3E33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/IconDelete.33dc711dccee75ec02d9bae0be02800b.svg";
export { ForwardRef as ReactComponent };